import React, { useEffect, useState } from 'react';
import styles from './User.module.css';
import GenericIconButton from '../GenericComponents/GenericIconButton';
import { useTranslation } from 'react-i18next';

interface ChangePasswordProps {
    user: any;
    onClose: () => void;
}

const ChangePassword: React.FC<ChangePasswordProps> = ({ user, onClose }) => {
    const { t } = useTranslation();
    const [localUser, setLocalUser] = useState({
        email: ''
    });
    const [pwdUser, setPwdUser] = useState({
        password: '',
        newpassword: '',
    });
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLocalUser(user.userDetails);
    }, [user.userDetails])

    const handleChange = (field: 'realname' | 'email' | 'password' | 'newpassword', value: string) => {
        setPwdUser(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${process.env.REACT_APP_USERMANAGEMENT_URL}?action=changepassword`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: localUser.email,
                    password: pwdUser.password,
                    newpassword: pwdUser.newpassword,
                }),
            });

            if (!response.ok) {
                throw new Error("Erreur " + response.statusText);
            }

            const result = await response.text();
            if (result === "Password Changed") {
                onClose();
            } else {
                throw new Error(result || "Erreur");
            }
        } catch (err) {
            console.error(t("error_updating"), err);
            setError(t("error_updating_failed"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.popupoverlay}>
            <div className={styles.popup} role="dialog" aria-modal="true" aria-labelledby="update-account-title">
                <div className={styles.header}>
                    <h2 id="update-account-title">Modifier votre mot de passe</h2>
                    <GenericIconButton
                        icon='light/times.svg'
                        width='18px'
                        height='18px'
                        onClick={onClose}
                        aria-label="Close"
                    />
                </div>
                <div className={styles.main}>
                    <form onSubmit={handleSubmit} className={styles.loginForm}>
                        <div className={styles.formGroup}>
                            <label htmlFor="update-email">E-mail</label>
                            <input
                                type="text"
                                id="update-email"
                                value={localUser.email}
                                required
                                readOnly
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label htmlFor="update-password">Mot de passe</label>
                            <input
                                type="password"
                                id="update-password"
                                value={pwdUser.password}
                                onChange={e => handleChange('password', e.target.value)}
                                required
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label htmlFor="update-newpassword">Nouveau mot de passe</label>
                            <input
                                type="password"
                                id="update-newpassword"
                                value={pwdUser.newpassword}
                                onChange={e => handleChange('newpassword', e.target.value)}
                                required
                            />
                        </div>
                        {error && (
                            <div className={styles.errorMessage}>
                                {error}
                            </div>
                        )}
                        <div className={styles.footer}>
                            <button
                                className={`${styles.loginSubmitButton}`}
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? "Mise à jour" : "Mettre à jour"}
                            </button>
                            <button
                                className={`${styles.cancelButton}`}
                                type="button"
                                onClick={onClose}
                            >
                                Annuler
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;
